import clsx from "clsx";

import styles from "./Ingredients.module.scss";

type Ingredient = { name: string; amount: string } | { note: string };

export interface IngredientsProps {
  subTitle?: string;
  ingredients: Ingredient[];
}

export function Ingredients({ subTitle, ingredients }: IngredientsProps): React.ReactNode {
  return (
    <>
      <p className={clsx("text__l text__bold pd__bottom__s", styles.ingredientsBorderBottomSolid)}>
        材料
        {subTitle && <span className="text__s text__gray__dark pd__left__xs">{subTitle}</span>}
      </p>
      <table className={styles.ingredientsTable}>
        <tbody>
          {ingredients.map((ingredient) =>
            "note" in ingredient ? (
              <tr key={ingredient.note} className={styles.ingredientsBorderBottomDotted}>
                <td colSpan={2} className="text__bold">
                  {ingredient.note}
                </td>
              </tr>
            ) : (
              <tr key={ingredient.name} className={styles.ingredientsBorderBottomDotted}>
                <td>{ingredient.name}</td>
                <td className="text__right">{ingredient.amount}</td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </>
  );
}
